import { render, staticRenderFns } from "./SelectionModePopup.vue?vue&type=template&id=63cc0af4&scoped=true&"
import script from "./SelectionModePopup.vue?vue&type=script&lang=js&"
export * from "./SelectionModePopup.vue?vue&type=script&lang=js&"
import style0 from "./SelectionModePopup.vue?vue&type=style&index=0&id=63cc0af4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cc0af4",
  null
  
)

export default component.exports